export const GA_EVENT_LABEL = 'branded_landing_pages'
